"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VIZ_TYPE;

(function (VIZ_TYPE) {
  VIZ_TYPE["CONTACT_MAP"] = "Contact Map";
  VIZ_TYPE["INFO_PANEL"] = "Info Panel";
  VIZ_TYPE["NGL"] = "NGL";
  VIZ_TYPE["SPRING"] = "Spring";
  VIZ_TYPE["TENSOR-T-SNE"] = "TENSOR-T-SNE";
  VIZ_TYPE["T-SNE"] = "T-SNE";
  VIZ_TYPE["T-SNE-FRAME"] = "T-SNE-FRAME";
})(VIZ_TYPE = exports.VIZ_TYPE || (exports.VIZ_TYPE = {}));

var CONTACT_DISTANCE_PROXIMITY;

(function (CONTACT_DISTANCE_PROXIMITY) {
  CONTACT_DISTANCE_PROXIMITY["CLOSEST"] = "CLOSEST";
  CONTACT_DISTANCE_PROXIMITY["C_ALPHA"] = "C-\u03B1";
})(CONTACT_DISTANCE_PROXIMITY = exports.CONTACT_DISTANCE_PROXIMITY || (exports.CONTACT_DISTANCE_PROXIMITY = {}));

var SECONDARY_STRUCTURE_CODES;

(function (SECONDARY_STRUCTURE_CODES) {
  SECONDARY_STRUCTURE_CODES["G"] = "310_HELIX";
  SECONDARY_STRUCTURE_CODES["H"] = "ALPHA_HELIX";
  SECONDARY_STRUCTURE_CODES["I"] = "PI_HELIX";
  SECONDARY_STRUCTURE_CODES["T"] = "HYDROGEN_BONDED_TURN";
  SECONDARY_STRUCTURE_CODES["E"] = "BETA_SHEET";
  SECONDARY_STRUCTURE_CODES["B"] = "BETA_BRIDGE";
  SECONDARY_STRUCTURE_CODES["S"] = "BEND";
  SECONDARY_STRUCTURE_CODES["C"] = "COIL";
})(SECONDARY_STRUCTURE_CODES = exports.SECONDARY_STRUCTURE_CODES || (exports.SECONDARY_STRUCTURE_CODES = {}));

var CHELL_CHART_EVENT_TYPE;

(function (CHELL_CHART_EVENT_TYPE) {
  CHELL_CHART_EVENT_TYPE[CHELL_CHART_EVENT_TYPE["AFTER_PLOT"] = 0] = "AFTER_PLOT";
  CHELL_CHART_EVENT_TYPE[CHELL_CHART_EVENT_TYPE["CLICK"] = 1] = "CLICK";
  CHELL_CHART_EVENT_TYPE[CHELL_CHART_EVENT_TYPE["DOUBLE_CLICK"] = 2] = "DOUBLE_CLICK";
  CHELL_CHART_EVENT_TYPE[CHELL_CHART_EVENT_TYPE["HOVER"] = 3] = "HOVER";
  CHELL_CHART_EVENT_TYPE[CHELL_CHART_EVENT_TYPE["RELAYOUT"] = 4] = "RELAYOUT";
  CHELL_CHART_EVENT_TYPE[CHELL_CHART_EVENT_TYPE["SELECTION"] = 5] = "SELECTION";
  CHELL_CHART_EVENT_TYPE[CHELL_CHART_EVENT_TYPE["UNHOVER"] = 6] = "UNHOVER";
})(CHELL_CHART_EVENT_TYPE = exports.CHELL_CHART_EVENT_TYPE || (exports.CHELL_CHART_EVENT_TYPE = {}));

var CHELL_CHART_PIECE;

(function (CHELL_CHART_PIECE) {
  CHELL_CHART_PIECE[CHELL_CHART_PIECE["AXIS"] = 0] = "AXIS";
  CHELL_CHART_PIECE[CHELL_CHART_PIECE["POINT"] = 1] = "POINT";
})(CHELL_CHART_PIECE = exports.CHELL_CHART_PIECE || (exports.CHELL_CHART_PIECE = {}));